import React, { memo } from 'react';
import makeBodyText from '../../../utils/makeText';
import styles from './index.module.scss';
const Item = memo(({ item, isHidden }) => {
    return (React.createElement("div", { className: `${styles.textData} ${isHidden ? styles.hiddenItem : ''}` },
        React.createElement("p", { className: `${makeBodyText('XL')} ${styles.text}` }, item.testimonial),
        React.createElement("span", { className: `${makeBodyText('XL')} ${styles.text}` },
            React.createElement("strong", null, item.author))));
});
Item.displayName = 'Item';
export default Item;
